import { useEffect } from "react";

export const useOnMount = (onMount: Function) => {
  useEffect(() => {
    return onMount && onMount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
